import { render, staticRenderFns } from "./consumabletype.vue?vue&type=template&id=1aee5704&"
import script from "./consumabletype.vue?vue&type=script&lang=js&"
export * from "./consumabletype.vue?vue&type=script&lang=js&"
import style0 from "./consumabletype.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports